const WingingChatIcon = ({ size }: { size: number }) => {
  return (
    <div
      style={{ width: size + "px", height: size + "px" }}
      className={
        "flex items-center justify-center overflow-hidden rounded-full bg-primary-dark"
      }
    >
      <img
        src={"/images/winging-chat.png"}
        alt={"Winging 챗봇 아이콘"}
        className="mt-[20px] h-[95%] w-[95%] object-contain"
      />
    </div>
  );
};

export default WingingChatIcon;
